/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

/**
 * Stringify param serializer for complex requests.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export default (params: any): string => {
    const qs: any = require('qs');
    return qs.stringify(params, { encode: false });
};
